<template>
  <div>
    <div class="audit1 page landscape">
      <Logo />
      <div class="flex">
        <div class="info">
          <div class="container">
            <center><h1>Zaawansowany audyt seo</h1></center>
            <h4>
              Aby poprawić ruch na twojej stronie niezbędny jest Audyt SEO
            </h4>
            <ul>
              <li>
                Twoja strona potrzebuje szczegółowej analizy SEO technicznej
              </li>
              <li>
                Przygotujemy rekomendacje na podstawie ponad 50 wytycznych,
                które poprawią działanie
              </li>
              <li>
                strony. Dzięki temu ruch wzrośnie i poprawi się widoczność
                strony na frazy z największym potencjałem wyszukiwania
              </li>
              <li>
                Damy Ci nielimitowane wsparcie we wdrożeniu wytycznych i
                będziemy pilnować projektu, aby dowieźć wszystkie niezbędne do
                osiągnięcia sukcesu zmiany
              </li>
            </ul>
            <h4>
              Otrzymasz pełny zestaw precyzyjnych wytycznych, dzięki którym:
            </h4>
            <ul>
              <li>
                Wzrośnie ruch w na Twojej stronie, a co za tym idzie liczba
                klientów
              </li>
              <li>
                Twój serwis będzie bardziej przyjazny dla użytkowników i robotów
                wyszukiwarek
              </li>
              <li>
                Poprawisz szybkość działania strony i jej ocenę w rankingach
                Google
              </li>
              <li>
                Audyt to inwestycja, która pracuje na wzrosty ruchu każdego dnia
                po wdrożeniu
              </li>
            </ul>
          </div>
          <center>
            <img
              src="/icon1.png"
              alt=""
              srcset=""
              style="
                width: 30%;
                margin: 0;
                padding: 0;
                margin-left: 0px;
                margin-top: -60px;
              "
            />
          </center>
        </div>
        <div class="bg-image">
          <div class="overlay"></div>
          <img src="/col5.jpg" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'Audit1',
  components: {
    Logo,
  },
  props: {
    msg: String,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audit1 {
  color: #000 !important;
  text-align: left;
}

.container {
  margin-top: 100px;
}
</style>
